export const SITE_PICKER_SET_SITE = 'SITE_PICKER_SET_SITE';
